import { render, staticRenderFns } from "./painting.vue?vue&type=template&id=3954bde9&"
import script from "./painting.vue?vue&type=script&lang=js&"
export * from "./painting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports